var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fake-input"},[_c('p',{staticClass:"label"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"value"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n    "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }